<template>
  <ConfigProvider :locale="zhCN">
    <div class="app-container">
      <router-view></router-view>
    </div>
  </ConfigProvider>
</template>
<script setup lang="ts">
// import { provide, watch } from "vue";
import { ConfigProvider, message, Modal  } from "ant-design-vue";
import zhCN from "ant-design-vue/es/locale/zh_CN";
import dayjs from "dayjs";
import "dayjs/locale/zh-cn";
import { onMounted } from "vue";

import { useUserStore } from "@/store";
// import { initSocket, websocketSendData } from "./services/websocket";
// import { watch } from "vue";
dayjs.locale("zh-cn");
let UserStore: any = useUserStore();
if(UserStore.userInfo && UserStore.userInfo.ico){
  let favicon = document.querySelector("link[rel*='icon']") as HTMLLinkElement;
  // 如果不存在favicon元素，则创建一个
  if (!favicon) {
    favicon = document.createElement('link');
    favicon.rel = 'icon';
    document.head.appendChild(favicon);
  }
  // 更新favicon的href
  favicon.href = UserStore.userInfo.ico;
}
// let websocket: WebSocket;
// if (UserStore.userInfo && UserStore.userInfo.authorization) {
//   // test websocket
//   websocket = initSocket(UserStore.userInfo.authorization);
//   websocket.onmessage = (event: any) => {
//     console.log(event, "aa");
//   };
// }
// watch(
//   () => UserStore.userInfo,
//   () => {
//     if (websocket) {
//       websocket.close();
//     }
//     if (UserStore.userInfo && UserStore.userInfo.authorization) {
//       websocket = initSocket(UserStore.userInfo.authorization);
//     }
//   }
// );

// 修改全局配置
ConfigProvider.config({
  theme: {
    primaryColor: "#2878FF",
  },
});

const debounce = (fn: any, delay: any) => {
  let timer: number | undefined;
  return (...args: any) => {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn(...args);
    }, delay);
  };
};

const _ResizeObserver = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ResizeObserver {
  constructor(callback: any) {
    callback = debounce(callback, 200);
    super(callback);
  }
};
function isMobileDevice() {
  // 检查User-Agent字符串中是否包含常见的移动设备标识
  return /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone|HarmonyOS)/i.test(navigator.userAgent);
}

function getCurrentDomain() {
  // 获取当前页面的域名（不包括协议和路径）
  return window.location.hostname;
}

function redirectToAppropriateDomain() {
  // 定义PC端和移动端的目标域名
  const pcDomain = "21yj.21cnjy.com";
  const mobileDomain = "21yjmobile.21cnjy.com";

  // 获取当前域名
  const currentDomain = getCurrentDomain();


  // 判断是否为移动端
  if (isMobileDevice()) {
      // 如果是移动设备且当前域名是PC端域名，且没有被重定向过，则跳转到移动端域名
      if (currentDomain == pcDomain) {
          // window.location.replace(`https://${mobileDomain}?redirected=true`);
          Modal.confirm({
            title: "温馨提示",
            content: "检测到您当前使用的是移动设备，是否跳转到移动端？",
            class: "custom-info-dialog",
            icon: null,
            centered: true,
            onOk: () => {
              window.location.replace(`https://${mobileDomain}`);
            },
          });
      }
  }
}
onMounted(() => {
  redirectToAppropriateDomain();
})
</script>
